import { createSlice, current } from '@reduxjs/toolkit';
import { sortedArray } from '../utils/utils';
export const customQuerySlice = createSlice({
  name: 'body',
  initialState: {
    entireDataArray: [],
    selectedDataArray: [],
    searchedText: '',
    type: '',
    activeTab: 2,
    searchChipArray: []
  },
  reducers: {
    pushAPIData: (state, action) => {
      state.entireDataArray = action.payload;
    },
    pushAuthToken: (state, action) => {
      state.authToken = action.payload;
    },
    pushSelectedDataItem: (state, action) => {
      state.dataItem = action.payload;
    },
    pushSelectedData: (state, action) => {
      let currentStateEntireData = current(state.entireDataArray);
      let {
        recordType,
        keyName
      } = action.payload;
      state.type = recordType;
      let selectedRecordData = currentStateEntireData.filter(item => item.type === recordType);
      let checkListData = selectedRecordData.length > 0 ? selectedRecordData[0].data && selectedRecordData[0].data.map((checkListItem, index) => {
        let toReturn = {};
        let key = keyName.toUpperCase().replace(/ /g, '_');

        if (Object.prototype.hasOwnProperty.call(checkListItem, key)) {
          toReturn.name = checkListItem[key];
          toReturn['checked'] = false;
          toReturn['index'] = index;
        }

        if (keyName.includes('Resource Name')) {
          toReturn['SERVICE_RESOURCE_TYPE'] = checkListItem['SERVICE_RESOURCE_TYPE'];
        }

        if (Object.prototype.hasOwnProperty.call(checkListItem, 'ENVIRONMENT') && recordType !== 'environments' && !keyName.includes('Type')) {
          toReturn['ENVIRONMENT'] = checkListItem['ENVIRONMENT'];
        }

        if (recordType === 'applications') {
          toReturn['APPLICATION_TYPE'] = checkListItem['APPLICATION_TYPE'];
        } else {
          if (Object.prototype.hasOwnProperty.call(checkListItem, 'APPLICATION') && !keyName.includes('Type')) {
            toReturn['APPLICATION'] = checkListItem['APPLICATION'];
          }
        }

        return toReturn;
      }) : [];
      checkListData = checkListData && checkListData.filter(item => item.name); // Filter out null values

      state.selectedDataArray = checkListData ? sortedArray(checkListData) : [];
    },
    pushOffsetLimit: (state, action) => {
      state.setOffsetLimit = action.payload;
    },
    setSearchString: (state, action) => {
      state.searchedText = action.payload;
    },
    pushActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    pushSearchChipArray: (state, action) => {
      let currentStateEntireData = current(state.entireDataArray);
      let {
        recordType,
        keyName
      } = action.payload;
      state.type = recordType;
      let selectedRecordData = currentStateEntireData.filter(item => item.type === recordType);
      let checkListData = selectedRecordData.length > 0 ? selectedRecordData[0].data && selectedRecordData[0].data.map((checkListItem, index) => {
        let toReturn = {};
        let key = keyName.toUpperCase().replace(/ /g, '_');

        if (Object.prototype.hasOwnProperty.call(checkListItem, key)) {
          toReturn.name = checkListItem[key];
          toReturn['checked'] = false;
          toReturn['index'] = index;
        }

        if (keyName.includes('Resource Name')) {
          toReturn['SERVICE_RESOURCE_TYPE'] = checkListItem['SERVICE_RESOURCE_TYPE'];
        }

        if (Object.prototype.hasOwnProperty.call(checkListItem, 'ENVIRONMENT') && recordType !== 'environments' && !keyName.includes('Type')) {
          toReturn['ENVIRONMENT'] = checkListItem['ENVIRONMENT'];
        }

        if (recordType === 'applications') {
          toReturn['APPLICATION_TYPE'] = checkListItem['APPLICATION_TYPE'];
        } else {
          if (Object.prototype.hasOwnProperty.call(checkListItem, 'APPLICATION') && !keyName.includes('Type')) {
            toReturn['APPLICATION'] = checkListItem['APPLICATION'];
          }
        }

        return toReturn;
      }) : [];
      checkListData = checkListData && checkListData.filter(item => item.name); // Filter out null values

      state.searchChipArray = checkListData ? sortedArray(checkListData) : [];
    },
    resetCustomQuery: state => {
      state.entireDataArray = [], state.selectedDataArray = [], state.searchedText = '', state.type = '', state.activeTab = 2, state.searchChipArray = [];
    },
    resetSearchData: state => {
      state.selectedDataArray = [], state.searchChipArray = [];
    },
    resetDeleteCustomQuery: state => {
      state.entireDataArray = [], state.selectedDataArray = [], state.searchedText = '', state.type = '', state.searchChipArray = [];
    }
  }
});
export const {
  pushAuthToken,
  pushAPIData,
  pushSelectedData,
  setSearchString,
  mutateSelectedArray,
  pushOffsetLimit,
  pushActiveTab,
  pushSelectedDataItem,
  pushSearchChipArray,
  resetCustomQuery,
  resetSearchData,
  resetDeleteCustomQuery
} = customQuerySlice.actions;
export default customQuerySlice.reducer;